import { makeStyles, Theme } from "@material-ui/core/styles";
import { BaseCSSProperties } from "@material-ui/core/styles/withStyles";
import { useAppState } from "../../../../common/appState";
import { useScreenSize } from "../../../../common/hooks/useScreenSize";
import { spaceBetween } from "../../../../common/util/Array/spaceBetween";
import { SeasonAnimation } from "../../Animations/SeasonAnimation";
import { PrimaryButton } from "../../Button/PrimaryButton";
import CharacterComment from "../../CharacterComment";
import { Markdown } from "../../Markdown";
import { SimpleDialogContentState } from "./type";

export function SimpleDialogContent({
    state: {
        title,
        message,
        buttonLabel,
        onButtonClick,
        season,
        titleStyle,
        innerContainerStyle,
    },
}: {
    state: SimpleDialogContentState;
}) {
    const c = useStyles({ titleStyle, innerContainerStyle });
    const { screenWidth } = useScreenSize();

    const [user] = useAppState("user");
    if (!user) {
        return null;
    }

    return (
        <div className={c.container}>
            <div className="center">
                <h2 className={spaceBetween("bold", c.title)}>{title}</h2>
            </div>

            <CharacterComment
                imgNumber={1}
                screenWidth={Math.min(300, screenWidth)}
                comment={
                    <Markdown
                        source={message}
                        noParagraphMarginBottom
                        noLinkShadow
                    />
                }
                style={{ margin: 0 }}
                commentStyle={{ padding: "12px 16px" }}
            />

            <PrimaryButton fullWidth onClick={onButtonClick}>
                {buttonLabel}
            </PrimaryButton>

            {season && (
                <SeasonAnimation
                    frequencySec={1}
                    screenWidth={600}
                    screenHeight={600}
                    isFestivalHidden
                    season={season}
                    fallingImgStyle={{ position: "absolute" }}
                />
            )}
        </div>
    );
}
const useStyles = makeStyles<
    Theme,
    { innerContainerStyle?: BaseCSSProperties; titleStyle?: BaseCSSProperties }
>({
    title: ({ titleStyle }) => ({
        ...titleStyle,
    }),
    container: ({ innerContainerStyle }) => ({
        margin: "10px 0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        height: 280,
        maxWidth: 288,
        position: "relative",
        ...innerContainerStyle,
    }),
    commentContainer: { whiteSpace: "pre-wrap", minWidth: 150 },
});
